import { FaqItems } from "./types";

export const faqItems: FaqItems = [
  {
    question: "What is Keyzy?",
    answer:
      "Keyzy is a rent-to-own homeownership product that helps first time buyers get on the property ladder. With Keyzy you can fix your rent for 2 years and buy at the end for a pre-agreed price (no increases!) If you choose to buy the home we will refund 100% of your rent to use as your deposit. Keyzy is not a normal landlord, we don’t need to make money from your rent. We succeed by selling the home to you at the end of your lease.",
  },
  {
    question: "How do referrals work?",
    answer:
      "Simply share your unique referral link with friends, family or colleagues. If they sign up to Keyzy using your link, you’ll earn £250 as a reward once they move into their Keyzy home.",
  },
  {
    question: "Who can I refer?",
    answer:
      "You can refer anyone who’s looking to rent or buy a home - friends, family, colleagues, or anyone in your network who might be interested in getting on the property ladder. To qualify for Keyzy, your referral must complete the application process and meet Keyzy’s eligibility criteria.",
  },
  {
    question: "When do I get paid?",
    answer:
      "You’ll receive your £250 once your referred friend officially signs their Keyzy agreement and moves into their new Keyzy home. We’ll notify you by email when it’s happened.",
  },
  {
    question: "How will I receive my reward?",
    answer:
      "Your £250 reward will be sent via bank transfer. We’ll ask for your payment details once your referral is confirmed.",
  },

  {
    question: "Is there a limit to how many people I can refer?",
    answer:
      "No limits! You can refer as many people as you like - and earn £250 for each successful referral.",
  },

  {
    question: "What counts as a ‘successful’ referral?",
    answer:
      "A referral counts once your friend signs their Keyzy agreement, is verified by our team, and moves in to their home.",
  },

  {
    question: "Can I refer someone who’s already applied to Keyzy?",
    answer:
      "Only new applicants who haven’t previously contacted or applied to Keyzy are eligible.",
  },

  {
    question: "Do I need to be a Keyzy customer to refer someone?",
    answer:
      "Nope! Anyone can participate in the referral program, whether you’re a current Keyzy user or just want to help a friend start their homeownership journey.",
  },

  {
    question: "How do I track my referrals?",
    answer: "You’ll be notified via email when and if your referral is successful.",
  },

  {
    question: " What if my friend doesn’t qualify for Keyzy?",
    answer:
      "If they apply but don’t meet our eligibility criteria or decide not to go ahead, the referral won’t count - but you can always refer someone else!",
  },

  {
    question: " How long does it take to receive the reward?",
    answer:
      "Once your referral signs their agreement, please allow up to 30 days for processing and payment.",
  },

  {
    question: " How do I keep track of my referrals?",
    answer:
      "We'll let you know if and when your referral has been successful, but we can't keep you up to date on the status of someone else's application without their permission. If you would like to know if your friend is going ahead with Keyzy, feel free to contact them directly.",
  },
];
